/**
 * Name: Edit Playlists Main
 * Author: @Gaurav
 * Date: 20-07-2021
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import search from '../../assets/ic_search.png';
import CopyIcn from '../../assets/copy_icn.svg';
import EditIcn from '../../assets/edit_icn.svg';
import Delete from '../../assets/Delete.png';
// import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../../pages/EditPlaylistMain/EditPlaylistMain.scss';
import { _showAlert, formatDateToDisplay } from '../../utils';
import { LoaderSpinner } from '../../components';
import AlertModal from '../../components/Modal';
import DownloadIcon from '../../components/Svgs/DownloadIcon.svg';
import ApiCaller from '../../redux/ApiCaller';
import { CircularProgress } from '@material-ui/core';

/**
 * style for material ui table
 */
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

function EditPlaylistMain(props) {
  const classes = useStyles();

  /**
   * getting state from redux store
   */
  const { getAllPlaylist, deletePlaylist, newPlaylistRequestData } = useSelector((state) => ({
    getAllPlaylist: state.getAllPlaylist.result,
    deletePlaylist: state.deletePlaylist.result,
    newPlaylistRequestData: state.newPlaylist.result,
  }));

  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [deleteSelectedPlaylist, setDeleteSelectedPlaylist] = useState(null);

  //* for downloading playlist
  const [downloadingPlaylistIndexes, setDownloadingPlaylistIndexes] = useState([]);

  /**
   * Close Modal
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * handle the delete api request
   * watch the changes of the deletePlaylist state
   */
  useEffect(() => {
    if (deletePlaylist.status === 200) {
      setLoading(false);
      _showAlert('Deleted successfully.', 'success');
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput });
    }
    if (deletePlaylist.error) {
      setLoading(false);
      _showAlert(deletePlaylist.error, 'error');
    }
  }, [deletePlaylist]);

  /**
   * handle the get playlist api request
   * watch the changes of the getAllPlaylist state
   */
  useEffect(() => {
    if (getAllPlaylist.error) {
      _showAlert(getAllPlaylist.error, 'error');
    }
    setLoading(false);
  }, [getAllPlaylist]);

  /**
   * call the get playlist api
   * watch the local state searchInput changes to search the playlist
   */
  useEffect(() => {
    dispatch({ type: 'GET_ALL_PLAYLIST', payload: searchInput });
  }, [searchInput]);

  /**
   * handle the duplicate new playlist api call
   * watch the changes of the newPlaylistRequestData redux state
   */
  useEffect(() => {
    if (newPlaylistRequestData && newPlaylistRequestData.id) {
      _showAlert('Playlist has been created successfully.', 'success');
      dispatch({ type: 'GET_ALL_PLAYLIST', payload: '' });
    }
    if (newPlaylistRequestData.error) {
      setLoading(false);
      _showAlert(newPlaylistRequestData.error, 'error', 10000);
    }
  }, [newPlaylistRequestData]);

  /**
   * clear the redux state of the api called in this component while component unmount
   */
  useEffect(() => {
    return () => {
      dispatch({ type: 'CLEAR_STATE', actionName: 'NEW_PLAYLIST' });
      dispatch({ type: 'CLEAR_STATE', actionName: 'DELETE_PLAYLIST' });
    };
  }, []);

  /**
   * will get called on click of edit icon
   */
  const handleEditClick = (selectedPlayList) => {
    props.history.push({
      pathname: '/edit-playlist-secondery',
      state: { selectedPlayList },
    });
  };

  /**
   * will get called on click of delete icon of row
   * will call the delete playlist api
   */

  const handleDelete = (item) => {
    setOpen(false);
    setLoading(true);
    dispatch({ type: 'DELETE_PLAYLIST', payload: { ids: [item.id] } });
  };
  /**
   * It will arrange the list according to date
   */
  function songs_sort(a, b) {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  }

  /**
   * will get called on click of duplicate icon of row
   * will call the new playlist api with selected playlist name and songs
   */
  const handleDuplicate = (playlist) => {
    setLoading(true);
    dispatch({ type: 'NEW_PLAYLIST', payload: { name: playlist.name, songs: playlist.songs } });
  };

  const downloadPlaylist = async (playlist, index) => {
    const updatedDownloadingIndexs = [...downloadingPlaylistIndexes, index];
    setDownloadingPlaylistIndexes(updatedDownloadingIndexs);

    _showAlert('Your playlist is downloading', 'success');
    await ApiCaller(`/v1/admin/playlists/${playlist.id}/download`, 'GET')
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${playlist.name}.zip`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        _showAlert(error.message, 'error');
      })
      .finally(() => {
        const updatedDownloadingIndexs = [...downloadingPlaylistIndexes];
        updatedDownloadingIndexs.splice(updatedDownloadingIndexs.indexOf(index), 1);
        setDownloadingPlaylistIndexes(updatedDownloadingIndexs);
      });
  };

  return (
    <>
      {isLoading && <LoaderSpinner />}
      <AlertModal open={open} onClose={handleClose} handelDelete={() => handleDelete(deleteSelectedPlaylist)} />
      <NavBar data="Edit Playlists" icon={Settings} currentRouteName="Playlists" breadcrumbsPath="Edit Playlists" />
      <div className="content">
        <div className="search_row">
          <input
            className="input_field"
            placeholder="Search something here..."
            type="text"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <img src={search} />
        </div>
        <TableContainer className="tbl_wraper" component={Paper}>
          <Table className={classes.table} stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                <TableCell className="table_font">Result</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Playlist Name</TableCell>
                <TableCell className="text_center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(getAllPlaylist)
                ? getAllPlaylist.sort(songs_sort).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{/* <Checkbox inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} /> */}</TableCell>
                      <TableCell align="justify" style={{ fontWeight: 'bold' }}>
                        <p style={{ paddingTop: '20px' }}>#{++index}</p>
                        {row.image ? (
                          <img
                            src={`${process.env.REACT_APP_API_URL}/playlists_images/${row.image}`}
                            crossorigin="anonymous"
                            alt="not-found"
                            className="imageContainerGet"
                          />
                        ) : (
                          <div className="thumbNail">
                            <p>{row.name?.[0]}</p>
                          </div>
                        )}
                      </TableCell>
                      <TableCell>{formatDateToDisplay(row.createdAt)}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>
                        <span className="action_icn">
                          {downloadingPlaylistIndexes.includes(index) ? (
                            <CircularProgress size={20} />
                          ) : (
                            <DownloadIcon className="icon" onClick={() => downloadPlaylist(row, index)} />
                          )}
                          <img onClick={() => handleDuplicate(row)} src={CopyIcn} />
                          <img src={EditIcn} onClick={() => handleEditClick(row)} />
                          <img
                            onClick={() => {
                              setOpen(true);
                              setDeleteSelectedPlaylist(row);
                            }}
                            src={Delete}
                          />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}

export default EditPlaylistMain;
